<template>
  <div class="payment-control-container">
    <modal
      class-name="payment-control-modal"
      v-model="showModal"
      width="840"
      :styles="{ top: '40px' }"
      :mask-closable="false"
      :footer-hide="true"
    >
      <div class="ms-subhead payment-control-title" slot="header">
        {{ modalTitle }}
      </div>
      <div class="payment-control-content">
        <template v-if="!activePayment">
          <div class="payment-control-header ms-help">
            <div>
              Список нераспределенных платежей из 1С для
              {{ companyTitle }} (последняя выгрузка: {{ receiveDate || "-" }})
            </div>
            <div>
              <i-button
                @click="exportTable"
                type="primary"
                icon="md-cloud-download"
              >
                Экспорт XLS
              </i-button>
            </div>
          </div>
          <inline-loader v-if="loading" :loading="loading" />
          <tabs v-model="tab" v-else>
            <tab-pane
              name="incoming"
              :label="`Входящие (${incomingPayments.length})`"
            >
              <pc-items
                v-if="tab === 'incoming'"
                :payments="incomingPayments"
              />
            </tab-pane>
            <tab-pane
              name="outgoing"
              :label="`Исходящие (${outgoingPayments.length})`"
            >
              <pc-items
                v-if="tab === 'outgoing'"
                :payments="outgoingPayments"
              />
            </tab-pane>
          </tabs>
        </template>
        <template v-else>
          <pc-distribute @update="getPayments" />
        </template>
      </div>
    </modal>
  </div>
</template>

<script>
import PcItems from './pc-items'
import PcDistribute from './pc-distribute'
import InlineLoader from '@/components/loaders/inline-loader'
import { formatDefaultDate, parseDateTime, downloadFile } from '@/utils'
import { mainUrl } from '@/config/urls'

export default {
  components: {
    PcItems,
    PcDistribute,
    InlineLoader
  },
  data () {
    return {
      loading: false,
      tab: 'incoming',
      incomingPayments: [],
      outgoingPayments: [],
      receiveDate: null,
      token: this.$store.state.auth.token
    }
  },
  watch: {
    showModal (value) {
      if (value) this.getPayments()
    }
  },
  computed: {
    showModal: {
      get () {
        return this.$store.state.paymentsControl.showModal
      },
      set (value) {
        this.$store.commit('TOGGLE_PC_PROP', { field: 'showModal', value })
      }
    },
    modalTitle () {
      return this.activePayment
        ? `Распределение платежа от ${formatDefaultDate(
          this.activePayment.date
        )}`
        : 'Распределение платежей из 1С'
    },
    activePayment () {
      return this.$store.state.paymentsControl.activePayment
    },
    companyTitle () {
      const { company } = this.$store.state.filters

      if (company === 'all') return 'всех компаний'

      return this.$store.state.companies.find((c) => c.id === company).name
    }
  },
  methods: {
    async getReceiveDate () {
      const url = `page/onec_last_time`
      const { last_time } = await this.$store.dispatch('GET_REQUEST', { url })

      this.receiveDate = last_time ? parseDateTime(last_time) : 'не определено'
    },
    async getPayments () {
      try {
        this.loading = true

        await this.getReceiveDate()

        const { company } = this.$store.state.filters
        let url = `page/onec_payment_distribution`
        if (company !== 'all') url += `?company_id=${company}`

        const allPayments = await this.$store.dispatch('GET_REQUEST', { url })
        const modifiedPayments = allPayments.map((payment) => ({
          ...payment,
          distributed_costs: payment.payments.reduce(
            (prev, p) => prev + p.value,
            0
          ),
          showDetails: false
        }))

        if (modifiedPayments) {
          this.$store.commit('TOGGLE_PC_PROP', {
            field: 'isNew',
            value: true
          })
        } else {
          this.$store.commit('TOGGLE_PC_PROP', {
            field: 'isNew',
            value: false
          })
        }

        this.incomingPayments = modifiedPayments.filter(
          (p) => p.incoming_payment
        )
        this.outgoingPayments = modifiedPayments.filter(
          (p) => p.outgoing_payment
        )

        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },
    exportTable () {
      const url = `${mainUrl}/api/page/onec_payment_distribution?format=excel&access_token=${this.token}`

      downloadFile(url)
    }
  },
  created () {
    this.getPayments()
  }
}
</script>

<style lang="less">
.payment-control {
  &-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &-title {
    text-align: center;
  }

  &-content {
    .ivu-tabs {
      &-nav {
        width: 100%;
      }

      &-tab {
        width: 50%;
        text-align: center;
      }
    }
  }
}
</style>
